import apiBancos from "@/app/services/bancos";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    banco: {
      id: '',
      descricao: ''
    },
    bancos: [],
    busca: "",
    total_itens: 0,
    paginacao: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['descricao'],
      sortDesc: [false]
    }
  },

  mutations: {
    LISTAR(state, bancos) {
      state.bancos = bancos;
    },

    ABRIR(state, banco) {
      state.banco = banco;
    },

    ADICIONAR(state, banco) {
      state.bancos.unshift(banco);
    },

    ATUALIZAR(state, banco) {
      let index = state.bancos.findIndex(peca_ => peca_.id == banco.id);
      if (index > -1) {
        state.bancos.splice(index, 1, banco);
      }
    },

    EXCLUIR(state, id) {
      let index = state.bancos.findIndex(banco => banco.id == id);
      if (index > -1) {
        state.bancos.splice(index, 1);
      }
    },

    SET_BUSCA(state, busca) {
      state.busca = busca;
    },

    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },

    SET_TOTAL_ITENS(state, total_itens) {
      state.total_itens = total_itens;
    },

    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },

    ZERAR(state) {
      state.banco = {
        id: '',
        descricao: '',
      };
    }
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;

      const paginacao = {
        page, 
        itemsPerPage,
        sortBy: sortBy[0], 
        sortDesc: sortDesc[0]
      }

      if (state.busca) {
        paginacao.busca = state.busca;
      }

      let response = await apiBancos.listar(paginacao);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      let banco = await apiBancos.abrir(id);
      commit('ABRIR', banco);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, banco) {
      let novopeca = await apiBancos.salvar(banco);
      commit('ADICIONAR', novopeca);
    },

    async atualizar({ commit }, banco) {
      await apiBancos.atualizar(banco);
      commit('ATUALIZAR', banco);
    },

    async excluir({ commit }, id) {
      await apiBancos.excluir(id);
      commit('EXCLUIR', id);
    },

  }
}
